var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTankLevel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 76,
    height: 76,
    rx: 8,
    fill: "#E8ECF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 22,
    width: 18,
    height: 32,
    rx: 1,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 27.8293C43.1872 27.9398 42.8506 28 42.5 28H21.5C21.1494 28 20.8128 27.9398 20.5 27.8293M43.5 27.8293C44.6652 27.4175 45.5 26.3062 45.5 25C45.5 23.3431 44.1569 22 42.5 22H21.5C19.8431 22 18.5 23.3431 18.5 25C18.5 26.3062 19.3348 27.4175 20.5 27.8293M43.5 27.8293V35.1707M43.5 35.1707C43.1872 35.0602 42.8506 35 42.5 35H21.5C21.1494 35 20.8128 35.0602 20.5 35.1707M43.5 35.1707C44.6652 35.5825 45.5 36.6938 45.5 38C45.5 39.3062 44.6652 40.4175 43.5 40.8293M43.5 40.8293C43.1872 40.9398 42.8506 41 42.5 41H21.5C21.1494 41 20.8128 40.9398 20.5 40.8293M43.5 40.8293V48.1707M43.5 48.1707C44.6652 48.5825 45.5 49.6938 45.5 51C45.5 52.6569 44.1569 54 42.5 54H21.5C19.8431 54 18.5 52.6569 18.5 51C18.5 49.6938 19.3348 48.5825 20.5 48.1707M43.5 48.1707C43.1872 48.0602 42.8506 48 42.5 48H21.5C21.1494 48 20.8128 48.0602 20.5 48.1707M20.5 48.1707L20.5 40.8293M20.5 40.8293C19.3348 40.4175 18.5 39.3062 18.5 38C18.5 36.6938 19.3348 35.5825 20.5 35.1707M20.5 35.1707V27.8293",
    stroke: "#272A35",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 24H57V28.5M57 28.5H53.5M57 28.5V33M57 33H50.5M57 33V38M57 38H53.5M57 38V43M57 43H50.5M57 43V48M57 48V53H50.5M57 48H53.5",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTankLevel);
export default __webpack_public_path__ + "static/media/icon-tank-level.14c53ef760d730499d435c5384a19a77.svg";
export { ForwardRef as ReactComponent };